module.exports = __webpack_public_path__ + "img/service04.58df5a44.png";